module.exports = __webpack_public_path__ + "img/awards_06.df20bc72.jpg";